import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';

@Pipe({
  name: 'rtCreditCardVendorIcon',
  pure: true,
  standalone: true,
})
export class CreditCardIconPipe implements PipeTransform {
  public static readonly availableCardIcons: IconName[] = [
    'amex',
    'dinners',
    'discover',
    'mastercard',
    'visa',
  ];

  public transform(value: string, fallback: 'credit-card'): IconName {
    return (
      (value && CreditCardIconPipe.availableCardIcons.find(name => name === value.toLowerCase())) ||
      fallback
    );
  }
}
